import React from "react";
import { useNavigate } from "react-router-dom";
import { useLeagueInfo } from "../../../Context/LeagueInfoContext/LeagueInfoContext";
import { useLeagueStore } from "../../../zustandStore/leagueStore";
import { hapticsImpactLight } from "../../../lib/utils";
import { actions } from "../../../Redux/store";
import selectLeague from "../../../assets/imgs/select_league.svg";
import LeagueActiveDot from "../LeagueSelectionModal/LeagueActiveDot";
import { ShimmerButton } from "../../ui/shimmer-button";
import { useMixpanel } from "../../../Context/MixpanelContext/MixpanelProvider";
import { useSupabaseAuth } from "../../../Context/AuthContext/AuthContext";
import { useRevenueCatAuth } from "../../../Context/RevenueCatContext/RevenueCatContext";

interface SelectLeagueButtonProps {
  className?: string;
}

export const SelectLeagueButton: React.FC<SelectLeagueButtonProps> = ({
  className = "",
}) => {
  const navigate = useNavigate();
  const { filteredLeagueData } = useLeagueInfo();
  const { selectedLeague } = useLeagueStore();
  const Mixpanel = useMixpanel();
  const { useAuthStore } = useSupabaseAuth();
  const {
    isSubscribed,
  } = useRevenueCatAuth();
  const isSuperUser = useAuthStore.getState().profile?.is_super_user;
  const leagueAccess = isSuperUser || isSubscribed;
  
  const toggleLeagueModal = () => {
    Mixpanel.trackEvent("league_sync_chip_selected", {
      name: "User clicked the Select League Sync chip",
    });
    hapticsImpactLight();
    
    // Check if user has league access
    if (!leagueAccess) {
      navigate('/chatbot-paywall-v2');
      return;
    }
    
    if (filteredLeagueData.length > 0) {
      actions.modal.openAddNewLeagueModal(null);
    } else {
      actions.modal.openLeagueModal(null);
    }
  };

  return (
    <ShimmerButton
      className={`flex items-center justify-center border-white/10 shadow-none [&>div]:shadow-none rounded-[34px] w-fit h-[24px] px-[8px] m-2 ${className}`}
      background="#1A1E2B"
      shimmerColor="#ffffff"
      borderRadius="34px"
      onClick={toggleLeagueModal}
    >
      {selectedLeague && <LeagueActiveDot />}
      <span className="text-[10px] text-white font-medium whitespace-nowrap overflow-hidden text-ellipsis max-w-[75px] pl-[4px]">
        {selectedLeague?.league_name || "Select League"}
      </span>
      <div className="pl-[5px]">
        <img src={selectLeague} alt="selectLeague" />
      </div>
    </ShimmerButton>
  );
};
